import {FC, Fragment, useEffect} from "react";
import styled from "styled-components";
import {Outlet} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {helpPagesLinks} from "modules/constants";
import {requestHelpPages} from "modules/actions";
import {getIsHelpsLoading} from "modules/selectors";
import {Aside, Navigation, PagePreloader} from "components";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 1240px;
	width: 100%;
	margin: 0 auto;
	gap: 20px;
	text-align: left;

	${({theme}) => theme.breakpoints.up("tablet")} {
		padding: 40px 20px;
		flex-direction: row;
	}
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;

	${({theme}) => theme.breakpoints.up("mobile")} {
		gap: 20px;
	}
`;

export const HelpLayout: FC = () => {
	const dispatch = useDispatch();
	const isLoading = useSelector(getIsHelpsLoading);

	useEffect(() => {
		dispatch(requestHelpPages());
	}, [dispatch]);

	if (isLoading) {
		return <PagePreloader />;
	}

	return (
		<Fragment>
			{/*<SubHeader />*/}

			<Wrapper>
				<Container>
					<Navigation links={helpPagesLinks} />
					<Outlet />
				</Container>

				<Aside breakpoint="tablet" />
			</Wrapper>
		</Fragment>
	);
};
